import { $createParagraphNode, $getRoot, $isParagraphNode } from "lexical";

/**
 * 在根末尾保证有一个空段落并将选区移入；若最后一个子节点已是空段落则只移动选区（不重复追加）。
 * 须在 `editor.update` 内调用。
 */
export function $ensureTailEmptyParagraphAndSelect(): void {
  const root = $getRoot();
  const last = root.getChildren()[root.getChildren().length - 1];
  if ($isParagraphNode(last) && last.getTextContent().trim().length === 0) {
    (last as { selectStart?: () => void }).selectStart?.();
    return;
  }
  const p = $createParagraphNode();
  root.append(p);
  (p as { selectStart?: () => void }).selectStart?.();
}
